let payments = import('./payments/payments.vue');
let paymentsList = import('./payments/list/index.vue');
let paymentsItem = import('./payments/item/index.vue');
let paymentsItemNew = import('./payments/item/index.vue');

export default [
  {
    path: '/finances',
    component: () => import('./finances.vue'),
    children: [
      {
        path: 'payments',
        component: () => import('./paymentItems/payments.vue'),
        children: [
          {
            path: '/',
            component: () => import('./paymentItems/list/index.vue'),
            props: {details: false}
          },
          {
            path: 'add',
            meta: {
              add: true
            },
            component: () => paymentsItem,
          },
          {
            path: 'add/:action/:id',
            component: () => paymentsItem,
            props: true,
          },
          {
            path: 'add/:action/:id/:date',
            component: () => paymentsItem,
            props: true,
          },
          {
            path: 'edit/:id',
            component: () => paymentsItem,
            props: true,
          },
        ]
      },
      {
        path: 'payments-details',
        component: () => payments,
        children: [
          {
            path: '/',
            component: () => paymentsList,
            props: {details: true}
          },
          {
            path: 'add',
            component: () => paymentsItem,
          },
          {
            path: 'add/:action/:id',
            component: () => paymentsItem,
            props: true,
          },
          {
            path: 'add/:action/:id/:date',
            component: () => paymentsItem,
            props: true,
          },
          {
            path: 'edit/:id',
            component: () => paymentsItem,
            props: true,
          },
        ]
      },
      {
        path: 'regulars',
        component: () => import('./regulars/regulars.vue'),
        children: [
          {
            path: '/',
            component: () => import('./regulars/list/index.vue'),
          },
          {
            path: 'add',
            component: () => import('./regulars/item/item.vue'),
          },
          {
            path: 'add/:action/:id',
            component: () => import('./regulars/item/item.vue'),
            props: true,
          },
          {
            path: 'add/:action/:id/:date',
            component: () => import('./regulars/item/item.vue'),
            props: true,
          },
          {
            path: 'edit/:id',
            component: () => import('./regulars/item/item.vue'),
            props: true,
          },
        ]
      },
      {
        path: 'invoices',
        component: () => import('./invoices/invoices.vue'),
        children: [
          {
            path: '/',
            component: () => import('./invoices/list/index.vue'),
          },
          {
            path: 'add',
            component: () => import('./invoices/item/index.vue'),
          },
          {
            path: 'edit/:id',
            component: () => import('./invoices/item/index.vue'),
            props: true,
          },
        ]
      },
      {
        path: 'subsidies',
        component: () => import('../subsidies/index.vue'),
        children: [
          {
            path: '/',
            redirect: 'search'
          },
          {
            path: 'add',
            component: () => import('../subsidies/item/index.vue'),
          },
          {
            path: 'edit/:id',
            component: () => import('../subsidies/item/index.vue'),
            props: true,
          },
          {
            path: 'allocation/:id',
            component: () => import('../subsidies/item/index.vue'),
            props: true,
          },
          {
            path: 'edit/:id/:child',
            component: () => import('../subsidies/item/index.vue'),
            props: true,
          },
        ]
      },
      {
        path: 'subsidies/:path',
        component: () => import('../subsidies/index.vue'),
        props: true,
      },
      {
        path: 'certificates',
        component: () => import('../certificates/index.vue'),
        children: [
          {
            path: '/',
            redirect: 'search'
          },
          {
            path: 'add',
            component: () => import('../certificates/item/index.vue'),
          },
          {
            path: 'edit/:id',
            component: () => import('../certificates/item/index.vue'),
            props: true,
          },
        ]
      },
      {
        path: 'certificates/:path',
        component: () => import('../certificates/index.vue'),
        props: true,
      },


      {
        path: 'statements',
        component: () => import('./statements/statements.vue'),
        children: [
          {
            path: '/',
            component: () => import('./statements/list/index.vue'),
          },
        ]
      },
      {
        path: 'balance-sheet',
        component: () => import('../balance-sheet/index.vue'),
      },
      {
        path: 'online-cash',
        component: () => import('./onlineCash/index.vue'),
      },
      {
        path: 'prepay-cash',
        component: () => import('./prepayCash/index.vue'),
      },
    ]
  },
]
